<footer class="main-footer">
  <div class="container-dynamic d-flex">

    <span class="m-auto"></span>
    Developed by <a href="http://www.hecticus.com/"> Hecticus Software</a>
  </div>
</footer>
